import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { providedBy: "Datos de películas y streaming provistos por", and: "y" },
  en: { providedBy: "Movie and streaming data provided by", and: "and" },
});
